import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { Accordion, Text } from '@nxt-costco-com/forge-components';
import { SecondaryTitle } from 'src/components/CookieSettings/SecondaryTitle';
import type  { EssentialAccordionProps, EssentialSubtype } from './types';
import { headingPadding, lgSpacedBox } from 'src/constants/styles';

type entryType = EssentialSubtype[] | EssentialSubtype;

export const EssentialAccordion: FC<EssentialAccordionProps> = ({ state }: EssentialAccordionProps) => {
    const { t } = useTranslation('translation');
    const locale = state.selectedLanguage;

    let content;

    if (locale === 'en-CA' || locale === 'fr-CA') {
        content = (
            <Text variant='b2'>{t('accordians.essential.description')}</Text>
        );
    } else {
        const essentialSubtypes = t('accordians.essential.subtypes', { returnObjects: true }) as entryType;
        content = (
            <Box sx={lgSpacedBox}>
                {essentialSubtypes instanceof Array &&
                    essentialSubtypes.map(
                        (subtype) => (
                            <div key={subtype.key}>
                                <Text component='h4' variant='t5' bold={true} sx={headingPadding}>{subtype.name}</Text>
                                <Text variant='b2'>{subtype.description}</Text>
                            </div>
                        )
                    )}
            </Box>
        );
    }

    return (
        <Accordion
            title={t('accordians.essential.name')}
            variant={'t5'}
            secondaryComponent={<SecondaryTitle color="green.500" text={t('states.isAlwaysActive')} />}
        >
            {content}
        </Accordion>
    );
};
